// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/get-prototype-module-overview-request-schema',
  type: 'object',
  required: ['classId', 'moduleId', 'year'],
  properties: {
    classId: {
      type: 'integer',
    },
    moduleId: {
      type: 'integer',
    },
    year: {
      type: 'string',
    },
  },
} as IJSONSchema;

export default schema;
